// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__3ltiT","Open":"SideDrawer_Open__3sYyi","Close":"SideDrawer_Close__33ZKY","Logo":"SideDrawer_Logo__3rbct"};